webpackJsonp([1,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(31);
	__webpack_require__(30);
	__webpack_require__(27);
	var globalTel = __webpack_require__(6);
	__webpack_require__(2);
	window.language = 'USA';
	if (window.location.search.indexOf('locale=EN') > -1) {
	  language = 'USA';
	  $('.cmta').show();
	} else if (window.location.search.indexOf('locale=JP') > -1) {
	  language = 'JP';
	  $('.cmta').hide();
	} else if (window.location.search.indexOf('locale=KO') > -1) {
	  language = 'KO';
	  $('.cmta').hide();
	} else if (window.location.search.indexOf('locale=TH') > -1) {
	  language = 'TH';
	  $('.cmta').hide();
	} else if (window.location.search.indexOf('locale=zh-CN') > -1) {
	  language = 'zh-CN';
	  $('.cmta').show();
	}
	if (window.location.href.indexOf('joinTg') > -1) {
	  language = 'zh-CN';
	  $('.cmta').show();
	}
	$('body').addClass(language);
	
	$(function () {
	  //等待加载完语言将body展示
	  $('body').show();
	
	  $('.go_href li a').click(function () {
	    if ($(this).data('href')) {
	      var lanCur = language;
	      if (language == 'USA') {
	        lanCur = 'EN';
	      }
	      window.location.href = $(this).data('href') + '?locale=' + lanCur;
	    }
	  });
	  $('.navbar-header').click(function () {
	    var collapse = $('.navbar-collapse');
	    if (collapse.is(':visible')) {
	      $('.navbar-header a').removeClass('close');
	      collapse.hide();
	    } else {
	      $('.navbar-header a').addClass('close');
	      collapse.show();
	    }
	  });
	
	  //选择语言
	  var defaultIndex = 0;
	  var lanArr = [{ value: 'English', abbr: 'EN' }, { value: '日本語', abbr: 'JP' }, { value: '한국어', abbr: 'KO' }, { value: 'ภาษาไทย', abbr: 'TH' }, { value: '简体中文', abbr: 'zh-CN' }];
	
	  var locationPathname = window.location.pathname;
	  if (locationPathname == '/tanchen.html') {
	    if (language == 'USA' || language == 'zh-CN') {
	      lanArr = [{ value: 'English', abbr: 'EN' }, { value: '简体中文', abbr: 'zh-CN' }];
	    }
	  }
	  var lanCur = language;
	  if (language == 'USA') {
	    lanCur = 'EN';
	  }
	  for (var i = 0; i < lanArr.length; i++) {
	    if (lanArr[i].abbr == lanCur) {
	      defaultIndex = i;
	      break;
	    }
	  }
	  var title = chooseLanguage[language];
	  var okText = toolbarCloseText[language];
	  var cancelText = submitCancelBtn[language];
	  var $countryInput = $('#country-input');
	  // 参数说明详见 picker.js
	  $countryInput.picker({
	    title: title,
	    okText: okText,
	    cancelText: cancelText,
	    data: lanArr,
	    name: 'value',
	    value: 'value',
	    selectedIndex: defaultIndex,
	    pickerId: 'country-picker',
	    onOk: function (selectedValue, selectedIndex) {
	      for (var i = 0; i < lanArr.length; i++) {
	        if (lanArr[i].value == selectedValue && lanCur != lanArr[i].abbr) {
	          window.location.href = window.location.origin + window.location.pathname + '?locale=' + lanArr[i].abbr;
	          break;
	        }
	      }
	    },
	    onCancel: function () {}
	  });
	
	  //选择电话前缀
	  var telArr = [];
	  var defaultIndexTel = 0;
	  var $submitInfoTelPre = $('#submitInfoTelPre');
	  var telPreCurrent = $submitInfoTelPre.text().split('+')[1];
	  var titleTel = chooseTelPre[language];
	  for (var i = 0; i < globalTel.length; i++) {
	    var value = globalTel[i].code + '-' + globalTel[i].countryAbbr;
	    telArr.push({ value: value });
	    if (globalTel[i].code == telPreCurrent) {
	      defaultIndexTel = i;
	    }
	  }
	  // 参数说明详见 picker.js
	  $submitInfoTelPre.picker({
	    title: titleTel,
	    okText: okText,
	    cancelText: cancelText,
	    data: telArr,
	    name: 'value',
	    value: 'value',
	    selectedIndex: defaultIndexTel,
	    pickerId: 'submitInfoTelPre-picker',
	    onOk: function (selectedValue, selectedIndex) {
	      $("#submitInfoTelPre").text('+' + selectedValue.split('-')[0]);
	    },
	    onCancel: function () {}
	  });
	});

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

	var config = {
	  scheme: 'release',
	  env: {
	    alpha: {
	      prefix: ''
	    },
	    beta: {
	      prefix: '/admin',
	      basicUrl: 'http://dev.lvyuetravel.com:8080',
	      imagesUrl: 'http://test.static.lvyuetravel.com/www/zh/static/images/',
	      senCondjs: 'http://dev.lvyuetravel.com:8080/static/sensorsdata.min.js',
	      senCond: 'https://shence.lvyuetravel.com/sa?project=default'
	    },
	    test: {
	      prefix: '',
	      basicUrl: 'http://test.www.lvyuetravel.com',
	      imagesUrl: 'http://test.static.lvyuetravel.com/www/zh/static/images/',
	      senCondjs: 'http://test.static.lvyuetravel.com/www/zh/static/sensorsdata.min.js',
	      senCond: 'https://shence.lvyuetravel.com/sa?project=default'
	    },
	    integrate: {
	      prefix: '',
	      basicUrl: 'http://www.integrate.lvyuetravel.com',
	      imagesUrl: 'http://static.integrate.lvyuetravel.com/www/zh/static/images/',
	      senCondjs: 'http://static.integrate.lvyuetravel.com/www/zh/static/sensorsdata.min.js',
	      senCond: 'https://shence.lvyuetravel.com/sa?project=default'
	    },
	    production: {
	      prefix: '',
	      basicUrl: 'https://www.lvyuetravel.com',
	      imagesUrl: 'https://static.lvyuetravel.com/www/zh/static/images/',
	      senCondjs: 'https://static.lvyuetravel.com/www/zh/static/sensorsdata.min.js',
	      senCond: 'https://shence.lvyuetravel.com/sa?project=production'
	    }
	  },
	  domains: {
	    urlStatic: '',
	    loginSite: 'http://test.www.lvyuetravel.com'
	  }
	};
	
	// 环境切换
	if (false) {
	  config.scheme = 'beta';
	} else if (false) {
	  config.scheme = 'devx';
	} else if (false) {
	  config.scheme = 'test';
	} else if (false) {
	  config.scheme = 'integrate';
	} else if (true) {
	  config.scheme = 'production';
	}
	module.exports = config;

/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

	
	
	var config = __webpack_require__(1);
	config = config.env[config.scheme];
	// var xecond= config.env[config.scheme].senCond
	(function (para) {
	  //神策
	  var p = para.sdk_url,
	      n = para.name,
	      w = window,
	      d = document,
	      s = 'script',
	      x = null,
	      y = null;
	  w['sensorsDataAnalytic201505'] = n;
	  w[n] = w[n] || function (a) {
	    return function () {
	      (w[n]._q = w[n]._q || []).push([a, arguments]);
	    };
	  };
	  var ifs = ['track', 'quick', 'register', 'registerPage', 'registerOnce', 'clearAllRegister', 'trackSignup', 'trackAbtest', 'setProfile', 'setOnceProfile', 'appendProfile', 'incrementProfile', 'deleteProfile', 'unsetProfile', 'identify', 'login', 'logout', 'trackLink', 'clearAllRegister'];
	  for (var i = 0; i < ifs.length; i++) {
	    w[n][ifs[i]] = w[n].call(null, ifs[i]);
	  }
	  if (!w[n]._t) {
	    x = d.createElement(s), y = d.getElementsByTagName(s)[0];
	    x.async = 1;
	    x.src = p;
	    w[n].para = para;
	    y.parentNode.insertBefore(x, y);
	  }
	})({
	  sdk_url: config.senCondjs,
	  name: 'sensors',
	  server_url: config.senCond,
	  // server_url:' http://shence.lvyuetravel.com:8107',
	  cross_subdomain: true,
	  heatmap: {
	    //是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
	    clickmap: 'default',
	    //是否开启触达注意力图，默认 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
	    scroll_notice_map: 'not_collect'
	  }
	});
	sensors.registerPage({ platformType: 'h5' });
	sensors.quick('autoTrack'); //神策系统必须是1.4最新版及以上

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

	
	var globalTel = [{
	  "lang": "zh-CN",
	  "code": "86",
	  "country": "中国",
	  "countryAbbr": "CN",
	  "sortIndex": 1
	}, {
	  "lang": "zh-CN",
	  "code": "852",
	  "country": "中国香港",
	  "countryAbbr": "HK",
	  "sortIndex": 2
	}, {
	  "lang": "zh-CN",
	  "code": "853",
	  "country": "中国澳门",
	  "countryAbbr": "MO",
	  "sortIndex": 3
	}, {
	  "lang": "zh-CN",
	  "code": "886",
	  "country": "中国台湾",
	  "countryAbbr": "TW",
	  "sortIndex": 4
	}, {
	  "lang": "zh-CN",
	  "code": "66",
	  "country": "泰国",
	  "countryAbbr": "TH",
	  "sortIndex": 5
	}, {
	  "lang": "zh-CN",
	  "code": "1",
	  "country": "美国",
	  "countryAbbr": "US",
	  "sortIndex": 6
	}, {
	  "lang": "zh-CN",
	  "code": "82",
	  "country": "韩国",
	  "countryAbbr": "KR",
	  "sortIndex": 7
	}, {
	  "lang": "zh-CN",
	  "code": "81",
	  "country": "日本",
	  "countryAbbr": "JP",
	  "sortIndex": 8
	}, {
	  "lang": "zh-CN",
	  "code": "65",
	  "country": "新加坡",
	  "countryAbbr": "SG",
	  "sortIndex": 9
	}, {
	  "lang": "zh-CN",
	  "code": "975",
	  "country": "不丹",
	  "countryAbbr": "BT",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "670",
	  "country": "东帝汶",
	  "countryAbbr": "TL",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "236",
	  "country": "中非共和国",
	  "countryAbbr": "CF",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "45",
	  "country": "丹麦",
	  "countryAbbr": "DK",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "380",
	  "country": "乌克兰",
	  "countryAbbr": "UA",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "998",
	  "country": "乌兹别克斯坦",
	  "countryAbbr": "UZ",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "256",
	  "country": "乌干达",
	  "countryAbbr": "UG",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "598",
	  "country": "乌拉圭",
	  "countryAbbr": "UY",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "235",
	  "country": "乍得",
	  "countryAbbr": "TD",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "967",
	  "country": "也门",
	  "countryAbbr": "YE",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "374",
	  "country": "亚美尼亚",
	  "countryAbbr": "AM",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "972",
	  "country": "以色列",
	  "countryAbbr": "IL",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "964",
	  "country": "伊拉克",
	  "countryAbbr": "IQ",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "98",
	  "country": "伊朗",
	  "countryAbbr": "IR",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "501",
	  "country": "伯利兹",
	  "countryAbbr": "BZ",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "238",
	  "country": "佛得角",
	  "countryAbbr": "CV",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "7",
	  "country": "俄罗斯",
	  "countryAbbr": "RU",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "359",
	  "country": "保加利亚",
	  "countryAbbr": "BG",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "385",
	  "country": "克罗地亚",
	  "countryAbbr": "HR",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "1671",
	  "country": "关岛",
	  "countryAbbr": "GU",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "220",
	  "country": "冈比亚",
	  "countryAbbr": "GM",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "354",
	  "country": "冰岛",
	  "countryAbbr": "IS",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "224",
	  "country": "几内亚",
	  "countryAbbr": "GN",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "245",
	  "country": "几内亚比绍共和国",
	  "countryAbbr": "GW",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "423",
	  "country": "列支敦士登",
	  "countryAbbr": "LI",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "243",
	  "country": "刚果",
	  "countryAbbr": "CD",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "242",
	  "country": "刚果民主共和国",
	  "countryAbbr": "CG",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "218",
	  "country": "利比亚",
	  "countryAbbr": "LY",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "231",
	  "country": "利比里亚",
	  "countryAbbr": "LR",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "1",
	  "country": "加拿大",
	  "countryAbbr": "CA",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "233",
	  "country": "加纳",
	  "countryAbbr": "GH",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "241",
	  "country": "加蓬",
	  "countryAbbr": "GA",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "36",
	  "country": "匈牙利",
	  "countryAbbr": "HU",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "211",
	  "country": "南苏丹",
	  "countryAbbr": "SS",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "27",
	  "country": "南非",
	  "countryAbbr": "ZA",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "267",
	  "country": "博茨瓦纳",
	  "countryAbbr": "BW",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "974",
	  "country": "卡塔尔",
	  "countryAbbr": "QA",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "250",
	  "country": "卢旺达",
	  "countryAbbr": "RW",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "352",
	  "country": "卢森堡",
	  "countryAbbr": "LU",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "91",
	  "country": "印度",
	  "countryAbbr": "IN",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "62",
	  "country": "印度尼西亚",
	  "countryAbbr": "ID",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "502",
	  "country": "危地马拉",
	  "countryAbbr": "GT",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "593",
	  "country": "厄瓜多尔",
	  "countryAbbr": "EC",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "963",
	  "country": "叙利亚",
	  "countryAbbr": "SY",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "53",
	  "country": "古巴",
	  "countryAbbr": "CU",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "996",
	  "country": "吉尔吉斯斯坦",
	  "countryAbbr": "KG",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "253",
	  "country": "吉布提",
	  "countryAbbr": "DJ",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "7",
	  "country": "哈萨克斯坦",
	  "countryAbbr": "KZ",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "57",
	  "country": "哥伦比亚",
	  "countryAbbr": "CO",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "506",
	  "country": "哥斯达黎加",
	  "countryAbbr": "CR",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "237",
	  "country": "喀麦隆",
	  "countryAbbr": "CM",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "993",
	  "country": "土库曼斯坦",
	  "countryAbbr": "TM",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "90",
	  "country": "土耳其",
	  "countryAbbr": "TR",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "1758",
	  "country": "圣卢西亚",
	  "countryAbbr": "LC",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "1869",
	  "country": "圣基茨和尼维斯",
	  "countryAbbr": "KN",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "239",
	  "country": "圣多美和普林西比",
	  "countryAbbr": "ST",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "508",
	  "country": "圣彼埃尔和密克隆岛",
	  "countryAbbr": "PM",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "1784",
	  "country": "圣文森特和格林纳丁斯",
	  "countryAbbr": "VC",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "378",
	  "country": "圣马力诺",
	  "countryAbbr": "SM",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "592",
	  "country": "圭亚那",
	  "countryAbbr": "GY",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "255",
	  "country": "坦桑尼亚",
	  "countryAbbr": "TZ",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "20",
	  "country": "埃及",
	  "countryAbbr": "EG",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "251",
	  "country": "埃塞俄比亚",
	  "countryAbbr": "ET",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "686",
	  "country": "基里巴斯",
	  "countryAbbr": "KI",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "992",
	  "country": "塔吉克斯坦",
	  "countryAbbr": "TJ",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "221",
	  "country": "塞内加尔",
	  "countryAbbr": "SN",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "381",
	  "country": "塞尔维亚",
	  "countryAbbr": "RS",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "232",
	  "country": "塞拉利昂",
	  "countryAbbr": "SL",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "357",
	  "country": "塞浦路斯",
	  "countryAbbr": "CY",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "248",
	  "country": "塞舌尔",
	  "countryAbbr": "SC",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "52",
	  "country": "墨西哥",
	  "countryAbbr": "MX",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "228",
	  "country": "多哥",
	  "countryAbbr": "TG",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "1809",
	  "country": "多明尼加共和国",
	  "countryAbbr": "DO",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "1767",
	  "country": "多米尼加",
	  "countryAbbr": "DM",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "43",
	  "country": "奥地利",
	  "countryAbbr": "AT",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "58",
	  "country": "委内瑞拉",
	  "countryAbbr": "VE",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "880",
	  "country": "孟加拉国",
	  "countryAbbr": "BD",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "244",
	  "country": "安哥拉",
	  "countryAbbr": "AO",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "1264",
	  "country": "安圭拉",
	  "countryAbbr": "AI",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "1268",
	  "country": "安提瓜和巴布达",
	  "countryAbbr": "AG",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "376",
	  "country": "安道尔",
	  "countryAbbr": "AD",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "691",
	  "country": "密克罗尼西亚",
	  "countryAbbr": "FM",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "505",
	  "country": "尼加拉瓜",
	  "countryAbbr": "NI",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "234",
	  "country": "尼日利亚",
	  "countryAbbr": "NG",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "227",
	  "country": "尼日尔",
	  "countryAbbr": "NE",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "977",
	  "country": "尼泊尔",
	  "countryAbbr": "NP",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "970",
	  "country": "巴勒斯坦领土",
	  "countryAbbr": "PS",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "1242",
	  "country": "巴哈马",
	  "countryAbbr": "BS",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "92",
	  "country": "巴基斯坦",
	  "countryAbbr": "PK",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "1246",
	  "country": "巴巴多斯",
	  "countryAbbr": "BB",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "675",
	  "country": "巴布亚新几内亚",
	  "countryAbbr": "PG",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "595",
	  "country": "巴拉圭",
	  "countryAbbr": "PY",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "507",
	  "country": "巴拿马",
	  "countryAbbr": "PA",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "973",
	  "country": "巴林",
	  "countryAbbr": "BH",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "55",
	  "country": "巴西",
	  "countryAbbr": "BR",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "226",
	  "country": "布基纳法索",
	  "countryAbbr": "BF",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "257",
	  "country": "布隆迪",
	  "countryAbbr": "BI",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "30",
	  "country": "希腊",
	  "countryAbbr": "GR",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "680",
	  "country": "帕劳",
	  "countryAbbr": "PW",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "682",
	  "country": "库克群岛",
	  "countryAbbr": "CK",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "1345",
	  "country": "开曼群岛",
	  "countryAbbr": "KY",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "49",
	  "country": "德国",
	  "countryAbbr": "DE",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "39",
	  "country": "意大利",
	  "countryAbbr": "IT",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "677",
	  "country": "所罗门群岛",
	  "countryAbbr": "SB",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "371",
	  "country": "拉脱维亚",
	  "countryAbbr": "LV",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "47",
	  "country": "挪威",
	  "countryAbbr": "NO",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "420",
	  "country": "捷克共和国",
	  "countryAbbr": "CZ",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "373",
	  "country": "摩尔多瓦",
	  "countryAbbr": "MD",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "212",
	  "country": "摩洛哥",
	  "countryAbbr": "MA",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "377",
	  "country": "摩纳哥",
	  "countryAbbr": "MC",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "673",
	  "country": "文莱达鲁萨兰国",
	  "countryAbbr": "BN",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "679",
	  "country": "斐济",
	  "countryAbbr": "FJ",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "268",
	  "country": "斯威士兰",
	  "countryAbbr": "SZ",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "421",
	  "country": "斯洛伐克",
	  "countryAbbr": "SK",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "386",
	  "country": "斯洛文尼亚",
	  "countryAbbr": "SI",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "94",
	  "country": "斯里兰卡",
	  "countryAbbr": "LK",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "687",
	  "country": "新喀里多尼亚",
	  "countryAbbr": "NC",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "44",
	  "country": "新泽西",
	  "countryAbbr": "JE",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "64",
	  "country": "新西兰",
	  "countryAbbr": "NZ",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "56",
	  "country": "智利",
	  "countryAbbr": "CL",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "850",
	  "country": "朝鲜",
	  "countryAbbr": "KP",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "855",
	  "country": "柬埔寨",
	  "countryAbbr": "KH",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "1473",
	  "country": "格林纳达",
	  "countryAbbr": "GD",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "299",
	  "country": "格陵兰岛",
	  "countryAbbr": "GL",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "995",
	  "country": "格鲁吉亚",
	  "countryAbbr": "GE",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "32",
	  "country": "比利时",
	  "countryAbbr": "BE",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "222",
	  "country": "毛里塔尼亚",
	  "countryAbbr": "MR",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "230",
	  "country": "毛里求斯",
	  "countryAbbr": "MU",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "676",
	  "country": "汤加",
	  "countryAbbr": "TO",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "966",
	  "country": "沙特阿拉伯",
	  "countryAbbr": "SA",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "33",
	  "country": "法国",
	  "countryAbbr": "FR",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "594",
	  "country": "法属圭亚那",
	  "countryAbbr": "GF",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "689",
	  "country": "法属波利尼西亚",
	  "countryAbbr": "PF",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "298",
	  "country": "法罗群岛",
	  "countryAbbr": "FO",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "48",
	  "country": "波兰",
	  "countryAbbr": "PL",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "1787",
	  "country": "波多黎各",
	  "countryAbbr": "PR",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "387",
	  "country": "波斯尼亚和黑塞哥维那",
	  "countryAbbr": "BA",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "263",
	  "country": "津巴布韦",
	  "countryAbbr": "ZW",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "504",
	  "country": "洪都拉斯",
	  "countryAbbr": "HN",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "509",
	  "country": "海地",
	  "countryAbbr": "HT",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "61",
	  "country": "澳大利亚",
	  "countryAbbr": "AU",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "353",
	  "country": "爱尔兰",
	  "countryAbbr": "IE",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "372",
	  "country": "爱沙尼亚",
	  "countryAbbr": "EE",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "1876",
	  "country": "牙买加",
	  "countryAbbr": "JM",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "1649",
	  "country": "特克斯和凯科斯群岛",
	  "countryAbbr": "TC",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "1868",
	  "country": "特立尼达和多巴哥",
	  "countryAbbr": "TT",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "591",
	  "country": "玻利维亚",
	  "countryAbbr": "BO",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "674",
	  "country": "瑙鲁",
	  "countryAbbr": "NR",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "46",
	  "country": "瑞典",
	  "countryAbbr": "SE",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "41",
	  "country": "瑞士",
	  "countryAbbr": "CH",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "590",
	  "country": "瓜德罗普岛",
	  "countryAbbr": "GP",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "678",
	  "country": "瓦努阿图",
	  "countryAbbr": "VU",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "262",
	  "country": "留尼汪",
	  "countryAbbr": "RE",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "375",
	  "country": "白俄罗斯",
	  "countryAbbr": "BY",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "1441",
	  "country": "百慕大群岛",
	  "countryAbbr": "BM",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "350",
	  "country": "直布罗陀",
	  "countryAbbr": "GI",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "500",
	  "country": "福克兰岛",
	  "countryAbbr": "FL",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "965",
	  "country": "科威特",
	  "countryAbbr": "KW",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "269",
	  "country": "科摩罗",
	  "countryAbbr": "KM",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "51",
	  "country": "秘鲁",
	  "countryAbbr": "PE",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "216",
	  "country": "突尼斯",
	  "countryAbbr": "TN",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "370",
	  "country": "立陶宛",
	  "countryAbbr": "LT",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "252",
	  "country": "索马里",
	  "countryAbbr": "SO",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "962",
	  "country": "约旦",
	  "countryAbbr": "JO",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "264",
	  "country": "纳米比亚",
	  "countryAbbr": "NA",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "95",
	  "country": "缅甸",
	  "countryAbbr": "MM",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "40",
	  "country": "罗马尼亚",
	  "countryAbbr": "RO",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "1340",
	  "country": "美属维尔京群岛",
	  "countryAbbr": "VI",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "856",
	  "country": "老挝",
	  "countryAbbr": "LA",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "254",
	  "country": "肯尼亚",
	  "countryAbbr": "KE",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "358",
	  "country": "芬兰",
	  "countryAbbr": "FI",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "249",
	  "country": "苏丹",
	  "countryAbbr": "SD",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "597",
	  "country": "苏里南",
	  "countryAbbr": "SR",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "44",
	  "country": "英国",
	  "countryAbbr": "GB",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "1284",
	  "country": "英属维尔京群岛",
	  "countryAbbr": "VG",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "31",
	  "country": "荷兰",
	  "countryAbbr": "NL",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "599",
	  "country": "荷属安的列斯群岛",
	  "countryAbbr": "AN",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "258",
	  "country": "莫桑比克",
	  "countryAbbr": "MZ",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "266",
	  "country": "莱索托",
	  "countryAbbr": "LS",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "63",
	  "country": "菲律宾",
	  "countryAbbr": "PH",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "503",
	  "country": "萨尔瓦多",
	  "countryAbbr": "SV",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "685",
	  "country": "萨摩亚",
	  "countryAbbr": "WS",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "351",
	  "country": "葡萄牙",
	  "countryAbbr": "PT",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "976",
	  "country": "蒙古",
	  "countryAbbr": "MN",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "1664",
	  "country": "蒙特塞拉特",
	  "countryAbbr": "MS",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "34",
	  "country": "西班牙",
	  "countryAbbr": "ES",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "225",
	  "country": "象牙海岸",
	  "countryAbbr": "CI",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "229",
	  "country": "贝宁",
	  "countryAbbr": "BJ",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "260",
	  "country": "赞比亚",
	  "countryAbbr": "ZM",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "240",
	  "country": "赤道几内亚",
	  "countryAbbr": "GQ",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "84",
	  "country": "越南",
	  "countryAbbr": "VN",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "994",
	  "country": "阿塞拜疆",
	  "countryAbbr": "AZ",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "93",
	  "country": "阿富汗",
	  "countryAbbr": "AF",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "213",
	  "country": "阿尔及利亚",
	  "countryAbbr": "DZ",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "355",
	  "country": "阿尔巴尼亚",
	  "countryAbbr": "AL",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "7",
	  "country": "阿布哈兹",
	  "countryAbbr": "AB",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "971",
	  "country": "阿拉伯联合酋长国",
	  "countryAbbr": "AE",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "968",
	  "country": "阿曼",
	  "countryAbbr": "OM",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "54",
	  "country": "阿根廷",
	  "countryAbbr": "AR",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "297",
	  "country": "阿鲁巴",
	  "countryAbbr": "AW",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "389",
	  "country": "马其顿",
	  "countryAbbr": "MK",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "960",
	  "country": "马尔代夫",
	  "countryAbbr": "MV",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "265",
	  "country": "马拉维",
	  "countryAbbr": "MW",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "596",
	  "country": "马提尼克",
	  "countryAbbr": "MQ",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "60",
	  "country": "马来西亚",
	  "countryAbbr": "MY",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "356",
	  "country": "马耳他",
	  "countryAbbr": "MT",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "261",
	  "country": "马达加斯加",
	  "countryAbbr": "MG",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "223",
	  "country": "马里",
	  "countryAbbr": "ML",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "961",
	  "country": "黎巴嫩",
	  "countryAbbr": "LB",
	  "sortIndex": 9999
	}, {
	  "lang": "zh-CN",
	  "code": "382",
	  "country": "黑山",
	  "countryAbbr": "ME",
	  "sortIndex": 9999
	}];
	
	module.exports = globalTel;

/***/ }),

/***/ 27:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 30:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 31:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// js/commons.26af96b6.js